import * as React from "react";
import { useClipboardText } from "../../utils/use-clipboard";
import { toast } from "react-toastify";

export const LinkCopier: React.FC<{ text: string }> = ({
  text,
}: {
  text: string;
}) => {
  const { buttonRef } = useClipboardText(text, () => {
    toast.success("クリップボードにコピーしました");
  });

  return (
    <div className="field has-addons">
      <div
        className="control has-icons-left is-expanded"
        style={{
          maxWidth: "700px",
        }}
      >
        <input className="input" value={text} />
        <span className="icon is-small is-left">
          <i className="fas fa-link" />
        </span>
      </div>
      <div className="control">
        <button
          className="button"
          ref={buttonRef}
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          コピー
        </button>
      </div>
    </div>
  );
};
